import React from "react";
import { DOCSTORE_PERMISSIONS } from "../../utils/docstoreTabs";

const DocStorePermissionCheckboxes = ({ enabled, value = [], onChange }) => {
  const handleToggle = (key) => {
    const updated = value.includes(key)
      ? value.filter((k) => k !== key)
      : [...value, key];
    onChange(updated);
  };

  if (!enabled) return null;

  return (
    <div>
      <div className="fnt15 fw-600 mb-3">Doc Store Permissions</div>

      <div className="row">
        {DOCSTORE_PERMISSIONS.map((perm) => (
          <div key={perm.key} className="col-md-4 col-sm-6 mb-2 ps-4">
            <div className="form-check d-flex align-items-center">
              <input
                className="form-check-input"
                type="checkbox"
                id={`docstore-perm-${perm.key}`}
                style={{ width: "16px", height: "16px" }}
                checked={value.includes(perm.key)}
                onChange={() => handleToggle(perm.key)}
              />
              <label
                className="form-check-label ms-2"
                htmlFor={`docstore-perm-${perm.key}`}
                style={{ fontSize: "0.95rem" }}
              >
                {perm.label}
              </label>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DocStorePermissionCheckboxes;
